// extracted by mini-css-extract-plugin
module.exports =  {"tooltipWrapper":"_SJh7aV4UuyBIEhVKdLQ","description":"hzq4858b8HdUWpuBnlcQ","disabled":"NZeLqB2_A9l7bwll9JzV"};